import React from 'react'
import './WhyChoose.css'
import img1 from '../images/why_img.webp';
import { AiFillRightSquare } from "react-icons/ai";
import Aos from "aos";
 import "aos/dist/aos.css";
  import { useEffect } from "react";

export default function WhyChoose() {

    useEffect(() => {
    Aos.init({
      duration: 1000,      // animation duration
      easing: "ease-in-out",
      once: true,          // animation happens only once
      offset: 100,         // offset from the trigger point
    });
  
    Aos.refresh(); // optional but recommended
  }, []);
  return (
    <div>
        <section className=" container-fluid ay-top-banner">
        <div className="container">
          <div className="ay-banner-content" style={{padding:'5%'}}>
            <p  className='radio-canada-bigg' style={{fontSize:'20px',color:'wheat'}}>
              Step into the healing embrace of time honored Ayurveda, where every therapy reflects centuries of wisdom. Let the gentle rhythm of nature, the potency of medicinal herbs, and the tender care of our experts restore your body, soothe your mind, and nurture your spirit.
            </p>

            
          </div>
        </div>
      </section>

      {/* ===== MAIN CONTENT ===== */}
      <section className=" container-fluid ay-main-section py-5" style={{backgroundColor:'#f7f0d3'}}>
        <div className="container">
          <div className="row align-items-center g-5">

            {/* LEFT CONTENT */}
            <div className="col-lg-6" data-aos="fade-up">
              <p className="ay-subtitle">WHY CHOOSE US</p>

              <h3 className="ay-heading head-font">
                Nature’s secret for your <br /> truly health
              </h3>
              <div className="ay-feature-list">
                <div className="ay-feature-item">
                  <span><AiFillRightSquare className='ay-icon' /></span>
                  <div>
                    <h6 className='para-font'>Authentic & Safe Ayurvedic Care</h6>
                    <p className='para-font justify-text'>A blend of herbs grown in our own garden and trusted Ayurvedic formulations ensures that our therapies are natural, safe, and deeply effective in promoting overall wellness and balance.</p>
                  </div>
                </div>

                <div className="ay-feature-item">
                  <span><AiFillRightSquare className='ay-icon' /></span>
                  <div>
                    <h6 className='para-font '>Specialized Postnatal Expertise</h6>
                    <p className='para-font justify-text' >Dedicated to postnatal Ayurvedic care, our treatments are designed specifically for new mothers recovery, with a deep understanding of hormonal balance, digestion, lactation, and strength restoration. Mothers and babies receive constant supervision throughout the treatment period, ensuring safety, comfort, and effective postnatal recovery.</p>
                  </div>
                </div>

                <div className="ay-feature-item">
                  <span><AiFillRightSquare className='ay-icon' /></span>
                  <div>
                    <h6 className='para-font'>Skilled & Compassionate Practitioners</h6>
                    <p className='para-font justify-text'>Our skilled doctors combine extensive knowledge of Ayurveda with a caring and personalized approach. They carefully assess your needs and design treatments that restore balance, strengthen your body, calm your mind and nurture your soul.</p>
                  </div>
                </div>
                 <div className="ay-feature-item">
                  <span><AiFillRightSquare className='ay-icon' /></span>
                  <div>
                    <h6 className='para-font'>Serene Healing Environment</h6>
                    <p className='para-font justify-text' >Experience the harmony of nature at our riverside retreat, surrounded by lush herbal gardens, where river view yoga sessions and gentle therapies restore your body, mind, and soul.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT VIDEO IMAGE */}
            <div className="col-lg-6" data-aos="fade-up-right">
              <div className="ay-video-wrapper mt-5">

                <img
                  src={img1}
                  alt="Ayurveda Spa"
                  className="img-fluid"
                />
             
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  )
}
